import React, { Component } from "react";
import { openURLInNewWindow } from "../../../../../../common/utils";

class TextMessage extends Component {
  handleClick = e => {
    if (this.props.data.text.indexOf("has expired. Please link your account. <a href") > 0) {
      e.preventDefault();
      openURLInNewWindow(
        this.props.data.text.substring(
          this.props.data.text.indexOf("https"),
          this.props.data.text.indexOf("target") - 2
        )
      );
    }
  };

  render() {
    return (
      <div
        className="sc-message--text"
        dangerouslySetInnerHTML={{ __html: this.props.data.text }}
        onClick={this.handleClick}
      />
    );
  }
}

export default TextMessage;
